import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleActivityMaster = {
  namespaced: true,

  state: {
    name: 'activity-master',
    nextSeqCode: null,
    activities: []
  },

  mutations,
  getters,
  actions
}

export default moduleActivityMaster;